export enum LoaderAction {
  START_LOADING = "START_LOADING",
  STOP_LOADING = "STOP_LOADING",
}
